import {Request} from '@simpli/serialized-request'

export interface ContactAttachmentPayload {
  filename: string
  content: string
}

export class ContactRequest {
  inquiryType: string | null = null
  name: string | null = null
  email: string | null = null
  relatedProduct: string | null = null
  message: string | null = null
  dappTitle: string | null = null
  dappLink: string | null = null
  companyName: string | null = null
  socialLink: string[] = []
  /** Codes of every network picked, empty when none was. */
  network: string[] = []
  mainnetContract: string[] = []
  tokens: string[] = []

  recaptchaToken: string | null = null

  attachments: ContactAttachmentPayload[] = []

  async submit() {
    return await Request.post(`/client/contact`, this)
      .name('submitContact')
      .asAny()
      .getData()
  }
}
